import { useLocation } from "wouter";

import { BulkExportType, BulkFileConfig, CompositeMapConfig, RorConfig } from "@nens/ldo/api-v1";

import { useBulkExportHook } from "../bulk-exports-hook";
import { getBulkExportListUrl } from "../routes";

import { BulkExportNewCore } from "./bulk-export-new-core";

const DEFAULT_BULK_CONFIG: BulkFileConfig = {
  excel_file_name: "metadata_export.xlsx",
};

const DEFAULT_COMPOSITE_CONFIG: CompositeMapConfig = {
  cell_size: 10,
  raster_types: ["max_waterdepth"],
};

const DEFAULT_ROR_CONFIG: RorConfig = {
  cell_size: 10,
  calculation_variant: "10",
  // All danger maps
  danger_maps: ["gg1", "gg2", "gg3", "gg4", "gg5", "vg1", "vg2", "vg3"],
  // All risk maps
  risk_maps: ["gr1", "gr2", "gr3", "vr1", "vr2", "vr3", "vr4"],
};

interface BulkExportNewProps {
  exportType: BulkExportType;
  clone?: string;
}

export function BulkExportNew({ exportType }: BulkExportNewProps) {
  return (
    <BulkExportNewCore
      exportType={exportType}
      defaultName=""
      defaultDescription=""
      defaultBulkConfig={DEFAULT_BULK_CONFIG}
      defaultCompositeConfig={DEFAULT_COMPOSITE_CONFIG}
      defaultRorConfig={DEFAULT_ROR_CONFIG}
      defaultExtra={{}}
    />
  );
}

// We use wrapper components for cloning
export function BulkExportClone({ exportType, clone }: BulkExportNewProps) {
  const { bulkExportResponse, actionAllowed } = useBulkExportHook(exportType, Number(clone), {
    loadScenarios: false,
  });
  const listUrl = getBulkExportListUrl(exportType);
  const setLocation = useLocation()[1];

  if (!bulkExportResponse.isSuccess) return null;

  const bulkExport = bulkExportResponse.data;

  if (bulkExport.type !== exportType || !actionAllowed("clone")) {
    setLocation(listUrl);
    return null;
  }

  return (
    <BulkExportNewCore
      exportType={exportType}
      defaultName={bulkExport.name}
      defaultDescription={bulkExport.description}
      defaultBulkConfig={
        exportType === "bulk_file" ? (bulkExport.config as BulkFileConfig) : DEFAULT_BULK_CONFIG
      }
      defaultCompositeConfig={
        exportType === "composite_map"
          ? (bulkExport.config as CompositeMapConfig)
          : DEFAULT_COMPOSITE_CONFIG
      }
      defaultRorConfig={
        exportType === "ror" ? (bulkExport.config as RorConfig) : DEFAULT_ROR_CONFIG
      }
      defaultExtra={{ scenario_ids: bulkExport.scenario_ids }}
    />
  );
}
